import React from "react";
import { Tooltip } from "antd";
import { TooltipProps, TooltipPropsWithTitle } from "antd/lib/tooltip";

interface ToolTipComponentProps extends TooltipPropsWithTitle {}

const ToolTipComponent = (props: ToolTipComponentProps) => {
  return <Tooltip className="tooltip" {...props} />;
};

export default ToolTipComponent;
